/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UserSettingsRouteImport } from './routes/user-settings'
import { Route as TemplatesRouteImport } from './routes/templates'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as MetricsRouteImport } from './routes/metrics'
import { Route as FeedbacksRouteImport } from './routes/feedbacks'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectProjectIdRouteImport } from './routes/project.$projectId'
import { Route as ProjectProjectIdSettingsRouteImport } from './routes/project_.$projectId_.settings'

const UserSettingsRoute = UserSettingsRouteImport.update({
  id: '/user-settings',
  path: '/user-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesRoute = TemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const MetricsRoute = MetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbacksRoute = FeedbacksRouteImport.update({
  id: '/feedbacks',
  path: '/feedbacks',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectProjectIdRoute = ProjectProjectIdRouteImport.update({
  id: '/project/$projectId',
  path: '/project/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectProjectIdSettingsRoute =
  ProjectProjectIdSettingsRouteImport.update({
    id: '/project_/$projectId_/settings',
    path: '/project/$projectId/settings',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/dashboard': typeof DashboardRoute
  '/feedbacks': typeof FeedbacksRoute
  '/metrics': typeof MetricsRoute
  '/register': typeof RegisterRoute
  '/templates': typeof TemplatesRoute
  '/user-settings': typeof UserSettingsRoute
  '/project/$projectId': typeof ProjectProjectIdRoute
  '/project/$projectId/settings': typeof ProjectProjectIdSettingsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/dashboard': typeof DashboardRoute
  '/feedbacks': typeof FeedbacksRoute
  '/metrics': typeof MetricsRoute
  '/register': typeof RegisterRoute
  '/templates': typeof TemplatesRoute
  '/user-settings': typeof UserSettingsRoute
  '/project/$projectId': typeof ProjectProjectIdRoute
  '/project/$projectId/settings': typeof ProjectProjectIdSettingsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/dashboard': typeof DashboardRoute
  '/feedbacks': typeof FeedbacksRoute
  '/metrics': typeof MetricsRoute
  '/register': typeof RegisterRoute
  '/templates': typeof TemplatesRoute
  '/user-settings': typeof UserSettingsRoute
  '/project/$projectId': typeof ProjectProjectIdRoute
  '/project_/$projectId_/settings': typeof ProjectProjectIdSettingsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/dashboard'
    | '/feedbacks'
    | '/metrics'
    | '/register'
    | '/templates'
    | '/user-settings'
    | '/project/$projectId'
    | '/project/$projectId/settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/dashboard'
    | '/feedbacks'
    | '/metrics'
    | '/register'
    | '/templates'
    | '/user-settings'
    | '/project/$projectId'
    | '/project/$projectId/settings'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/dashboard'
    | '/feedbacks'
    | '/metrics'
    | '/register'
    | '/templates'
    | '/user-settings'
    | '/project/$projectId'
    | '/project_/$projectId_/settings'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  DashboardRoute: typeof DashboardRoute
  FeedbacksRoute: typeof FeedbacksRoute
  MetricsRoute: typeof MetricsRoute
  RegisterRoute: typeof RegisterRoute
  TemplatesRoute: typeof TemplatesRoute
  UserSettingsRoute: typeof UserSettingsRoute
  ProjectProjectIdRoute: typeof ProjectProjectIdRoute
  ProjectProjectIdSettingsRoute: typeof ProjectProjectIdSettingsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/user-settings': {
      id: '/user-settings'
      path: '/user-settings'
      fullPath: '/user-settings'
      preLoaderRoute: typeof UserSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates': {
      id: '/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/metrics': {
      id: '/metrics'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof MetricsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedbacks': {
      id: '/feedbacks'
      path: '/feedbacks'
      fullPath: '/feedbacks'
      preLoaderRoute: typeof FeedbacksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project/$projectId': {
      id: '/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/project/$projectId'
      preLoaderRoute: typeof ProjectProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project_/$projectId_/settings': {
      id: '/project_/$projectId_/settings'
      path: '/project/$projectId/settings'
      fullPath: '/project/$projectId/settings'
      preLoaderRoute: typeof ProjectProjectIdSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  DashboardRoute: DashboardRoute,
  FeedbacksRoute: FeedbacksRoute,
  MetricsRoute: MetricsRoute,
  RegisterRoute: RegisterRoute,
  TemplatesRoute: TemplatesRoute,
  UserSettingsRoute: UserSettingsRoute,
  ProjectProjectIdRoute: ProjectProjectIdRoute,
  ProjectProjectIdSettingsRoute: ProjectProjectIdSettingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
